import { Component, computed, effect, inject, Signal, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-variable-dispatch-cell',
  templateUrl: './variable-dispatch-cell.component.html',
  imports: [MatTooltip, MatIcon],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./variable-dispatch-cell.component.scss']
})
export class VariableDispatchCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<ICellRendererParams & { isFilterRenderer?: boolean }> = signal(null);
  private translateService: TranslateService = inject(TranslateService);

  isIcon: WritableSignal<boolean> = signal(true);
  isDispatched: WritableSignal<boolean> = signal(false);
  value: WritableSignal<string> = signal(null);

  tooltip: Signal<string> = computed(() => {
    const params = this.params();
    return params?.value?.dispatchDestination
      ? this.translateService.instant('ASSETS.VARIABLE.DISPATCH_TOOLTIP', { dispatchDestination: params?.value?.dispatchDestination })
      : '';
  });

  constructor() {
    effect(() => {
      const params = this.params();
      if (!params) {
        return;
      }

      if (params.value === this.translateService.instant('AG_GRID.selectAll')) {
        this.isIcon.set(false);
        this.value.set(params.value);
      } else if (params.isFilterRenderer && !params.value?.isDispatched) {
        this.isIcon.set(false);
        this.value.set(this.translateService.instant('AG_GRID.blanks'));
      } else {
        this.isIcon.set(true);
        this.isDispatched.set(!!params.value?.isDispatched);
      }
    });
  }

  agInit(params: ICellRendererParams & { isFilterRenderer?: boolean }): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
